import React from "react";
import { calculateDate } from "../../utils/date";

const DateDisplay = ({ value }) => {
  return <span>{calculateDate(value)}</span>;
};

export default DateDisplay;
